<script>

export default {
	name: 'Alert',
	
	components: {
	
	},
	
	data() {
		return {
			
		}
	},
	
	props: {'type':String, 'label':String},

	mounted:function(){
		
	},
	
	methods: {
		
	},	
	
	watch: {
	
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
		<div :class="`alert alert-${type}`" role="alert">{{ label }}</div>
	</div>
</template>


